const axios = require('axios');
import store from '../store'

let baseURL = (process.env.API_BASE_URL !== undefined) ? process.env.API_BASE_URL : '//' + location.hostname

let ApiService = axios.create({
	baseURL,
	withCredentials: true,

	// timeout: 1000,
	// headers: {'X-Custom-Header': 'foobar'}
});

let vm = this;
ApiService.interceptors.response.use(response => {
	return response;
}, error => {
	if (error.response.status === 401) {
		store.dispatch('me/logout');
	}
	//will be caught by other try catch
	throw error;
});

export default ApiService;